import { parseISO } from 'date-fns';

export const parseDateStringWithoutTime = (date: string) => {
  const parseDate = parseISO(date);

  return new Date(
    parseDate.valueOf() + parseDate.getTimezoneOffset() * 60 * 1000
  );
};
